export default __webpack_public_path__ + "static/team_banner-2728b11a2b9a1bcb31ce01f7370d9c60.jpg";